import { c as _c } from "react/compiler-runtime";
import type { Address } from 'viem';
import { ZERO } from '@morpho-org/dapp-core';
import { TEMPO_CONNECTOR_ID } from '@repo/web3/utils';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useBundlerConfiguration } from '@/contexts/BundlerConfiguration';
import { resolveSignatureSupport } from '@/contexts/Web3Context/utils/resolveSignatureSupport';
import { useWeb3Context } from '@/contexts/Web3Context/Web3.context';
import { useVaultV2 } from '../../../hooks/useVaultV2';
export function useVaultV2DepositTransaction(t0) {
  const $ = _c(38);
  const {
    vaultAddress,
    vaultAsset,
    erc20Amount,
    nativeAmount: t1
  } = t0;
  const nativeAmount = t1 === undefined ? ZERO : t1;
  const {
    account,
    viemClient,
    targetChainId,
    allowSignatureRequirements
  } = useWeb3Context();
  const {
    vault,
    vaultData,
    vaultDataBlockNumber,
    isLoading: isVaultLoading
  } = useVaultV2(vaultAddress);
  const bundlerConfiguration = useBundlerConfiguration();
  const t2 = account.connector?.id === TEMPO_CONNECTOR_ID;
  let t3;
  if ($[0] !== account.isByteCodeResolved || $[1] !== account.isContract || $[2] !== account.isSafe || $[3] !== allowSignatureRequirements || $[4] !== t2) {
    t3 = resolveSignatureSupport({
      isSafe: account.isSafe,
      isTempoWallet: t2,
      allowSignatureRequirements,
      isByteCodeResolved: account.isByteCodeResolved,
      isContract: account.isContract
    });
    $[0] = account.isByteCodeResolved;
    $[1] = account.isContract;
    $[2] = account.isSafe;
    $[3] = allowSignatureRequirements;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const supportSignature = t3;
  let t4;
  if ($[6] !== bundlerConfiguration.withSimplePermit || $[7] !== vaultAsset) {
    t4 = bundlerConfiguration.withSimplePermit?.has(vaultAsset) ?? false;
    $[6] = bundlerConfiguration.withSimplePermit;
    $[7] = vaultAsset;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const useSimplePermit = t4;
  let t5;
  if ($[9] !== account.address || $[10] !== erc20Amount || $[11] !== nativeAmount || $[12] !== supportSignature || $[13] !== targetChainId || $[14] !== useSimplePermit || $[15] !== vaultAddress || $[16] !== vaultAsset || $[17] !== vaultDataBlockNumber || $[18] !== viemClient.uid) {
    t5 = ["vaultV2Deposit-prepared", vaultAddress, account.address, erc20Amount, nativeAmount, vaultDataBlockNumber, viemClient.uid, targetChainId, supportSignature, vaultAsset, useSimplePermit];
    $[9] = account.address;
    $[10] = erc20Amount;
    $[11] = nativeAmount;
    $[12] = supportSignature;
    $[13] = targetChainId;
    $[14] = useSimplePermit;
    $[15] = vaultAddress;
    $[16] = vaultAsset;
    $[17] = vaultDataBlockNumber;
    $[18] = viemClient.uid;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== account.address || $[21] !== erc20Amount || $[22] !== nativeAmount || $[23] !== useSimplePermit || $[24] !== vault || $[25] !== vaultData) {
    t6 = async () => {
      const transaction = vault.deposit({
        userAddress: account.address,
        ...(nativeAmount > ZERO ? {
          nativeAmount
        } : {
          amount: erc20Amount
        }),
        vaultData
      });
      const requirements = await transaction.getRequirements({
        useSimplePermit
      });
      return {
        transaction,
        requirements
      };
    };
    $[20] = account.address;
    $[21] = erc20Amount;
    $[22] = nativeAmount;
    $[23] = useSimplePermit;
    $[24] = vault;
    $[25] = vaultData;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  const t7 = !!account.address && !!vaultData && (erc20Amount > ZERO || nativeAmount > ZERO);
  let t8;
  if ($[27] !== t5 || $[28] !== t6 || $[29] !== t7) {
    t8 = {
      queryKey: t5,
      queryFn: t6,
      enabled: t7,
      gcTime: 0,
      placeholderData: keepPreviousData
    };
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  const {
    data: prepared,
    isLoading,
    isError,
    isPlaceholderData,
    error: requirementsError
  } = useQuery(t8);
  const t9 = prepared?.transaction;
  const t10 = prepared?.requirements;
  const t11 = isLoading || isVaultLoading;
  let t12;
  if ($[31] !== isError || $[32] !== isPlaceholderData || $[33] !== requirementsError || $[34] !== t10 || $[35] !== t11 || $[36] !== t9) {
    t12 = {
      transaction: t9,
      requirements: t10,
      hasRequirementsError: isError,
      isRequirementsStale: isPlaceholderData,
      requirementsError,
      isLoading: t11
    };
    $[31] = isError;
    $[32] = isPlaceholderData;
    $[33] = requirementsError;
    $[34] = t10;
    $[35] = t11;
    $[36] = t9;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  return t12;
}